
<svg :class="svgClass" :style="svgStyle">
  <!-- Important de garder href et xlink href: 
  problème de compatibilité avec certaines versions de navigateurs -->
  <use :xlink:href="name" :href="name" />
</svg>
